import { apiClient } from "../apiClient";

export const getCompanyLogo = async (companyId: string | number): Promise<Blob> => {
    return apiClient.blob(`/Company/GetCompanyLogo?companyId=${encodeURIComponent(companyId)}`);
};

export const updateCompanyLogo = async (companyId: number | string, body: any) => {
    return apiClient.post(`/Company/UpdateLogo?companyId=${companyId}`, body);
};
